<template>
	<header>
		<nav class="navbar navbar-expand-lg navbar-light fixed-top p-md-0 pt-0 pb-0">
			<nav class="container p-0">
				<router-link :to="{ name: 'dashboard' }" class="navbar-brand mr-0">
					<img class="img-fluid navbar-logo" width="85%" height="85%" src="assets/logo-milagros.png">
				</router-link>
				<span class="ml-n2 ml-md-0 text-white font-size-sm-11 font-size-15">MOBILE COUNTER</span>
				<button class="navbar-toggler">
					<span class="navbar-toggler-icon">
						<router-link :to="{ name: 'profile' }">
							<span class="text-white d-none d-xs-block">{{ profile.stockist_name}}</span>
							<div class="image-frame">
								<img :src="profile.stockist_image">
							</div>
						</router-link>
					</span>
				</button>
				<div class="collapse navbar-collapse" id="navbarNavDropdown">
					<ul class="navbar-nav ml-auto">
						<li class="nav-item ml-3">
							<router-link :to="{ name: 'profile' }">
								<div class="row pr-md-3">
									<span class="text-white mr-2 mt-2">{{ profile.stockist_name }} - {{profile.stockist_code}}</span>
									<div class="image-frame">
										<img :src="profile.stockist_image">
									</div>
								</div>
							</router-link>
						</li>
					</ul>
				</div>
			</nav>
		</nav>
		<div class="jumbotron jumbotron-fluid background-mila">
			<div class="container pb-3 pb-md-0">
				<div class="row">
					<div class="col-12 pb-4"></div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
	name: 'MlHeader',

	computed: {
		...mapState('profileList', ['profile']),
		...mapGetters('auth', ['isAuth']),
	},
	methods: {
		...mapActions('profileList', ['getProfile']),
	},
	created() {
		this.getProfile();
	},
}
</script>

<style scoped>
	.image-frame {
		width: 35px;
		height: 35px;
		border-radius: 50%;
		overflow: hidden;
	}
	.image-frame img {
		width: 3em;
		height: 3em;
		object-fit: cover;
		object-position: center;
	}
	@media (min-width: 100px) and (max-width: 320px) {
		.font-size-sm-11 {
			font-size: 9pt !important;
		}	
	}
</style>